import { Divider, Theme } from '@infotech-soe/erp-ui-kit';
import classNames from 'classnames';
import React, { memo } from 'react';
import { createUseStyles, useTheme } from 'react-jss';

import logoSrc from '../../assets/logo-header.svg';
import NotificationsContainer from '../notifications/NotificationsContainer';

import AccountMenuButton from './AccountMenuButton';
import { MainViewContainerProps } from './MainViewContainer';
import PanelLinksContainer from './PanelLinks';

type HeaderProps = Pick<MainViewContainerProps, 'appName' | 'userName'>;

const useStyles = createUseStyles(({ colors, sizes }: Theme) => ({
  button: {
    height: 'auto',
    padding: sizes.mainHeaderButton.padding,
  },
  icon: {
    fontSize: 24,
  },
  header: {
    composes: ['row', 'no-wrap'],
    height: sizes.mainHeader.height,
    background: colors.backgroundHeader,
    color: colors.typoHeader,
  },
  headerCol: {
    composes: ['flex'],
    lineHeight: 'normal',
    padding: sizes.mainHeader.padding,
  },
}));

const HeaderDivider = () => (
  <Divider className="m-ma-none" color="secondary" type="vertical" />
);

const Header: React.FC<HeaderProps> = ({ appName, userName }) => {
  const theme = useTheme<Theme>();
  const classes = useStyles();

  return (
    <div className={classes.header}>
      <div
        className={classNames(classes.headerCol, 'items-center', 'col-auto')}
      >
        <img src={logoSrc} alt="Infotech" height={theme.sizes.logo.height} />
        <div className="m-pl-md text-no-wrap">{appName}</div>
      </div>
      <HeaderDivider />
      <PanelLinksContainer />
      <HeaderDivider />
      <NotificationsContainer
        className={classNames(classes.button, classes.icon)}
      />
      <HeaderDivider />
      {userName && (
        <AccountMenuButton className={classes.button} userName={userName} />
      )}
    </div>
  );
};

export default memo(Header);
